import rateComment from "@/components/features/rate-comment/index.vue";
import {mapActions, mapMutations} from "vuex";

export default {
    name: "GraduateWorkRateComment",
    components: {
        rateComment,
    },
    props: {
        graduateWork: {
            required: true,
            type: Object,
        },
        focusInput: {
            type: Boolean,
            default: false,
        },
        courseId: {
            required: true,
            type: Number
        }
    },
    data() {
        return {
            progress: false,
            comment: "",
            inEdit: false
        };
    },
    computed: {
        hasCreatedRateMessage() {
            return Boolean(
                !Array.isArray(this.graduateWork.userRating.data) &&
                this.graduateWork.userRating.data.comment
            );
        },
        storedComment() {
            return this.graduateWork.userRating.data.comment;
        },
    },
    mounted() {
        this.comment = this.storedComment;
    },
    watch: {
        'graduateWork.userRating.data'(rate) {
            if (rate.rating) {
                this.inEdit = true;
            }
        },
    },
    methods: {
        ...mapMutations({
            setLessonRate: "coursesGraduateWork/SET_RATE",
        }),
        ...mapActions({
            updateRateComment: "coursesGraduateWork/UPDATE_RATE_COMMENT",
        }),
        async onSubmit(comment) {
            try {
                this.progress = true;
                await this.updateRateComment({
                    courseId: this.courseId,
                    rateId: this.graduateWork.userRating.data.id,
                    comment,
                });
                this.inEdit = false;
            } catch (e) {
                // TODO: show toast
                console.error(e.message);
            } finally {
                this.progress = false;
            }
        },
        onCancel() {
            this.inEdit = false;
            this.comment = this.storedComment;
        },
        onNeedEdit() {
            this.inEdit = true;
        }
    },
};
